import React, { useCallback } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { getDeviationResourceType } from '../../_helpers';
import PopperDropdownManager from '../../../Dropdown/PopperDropdownLayout/PopperDropdownManager';
import PopperDropdownToggle from '../../../Dropdown/PopperDropdownLayout/PopperDropdownToggle';
import StandardDropdownMenu from '../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '../../../Dropdown/hooks/useDropdownItems';
import s from './ThumbActions.scss';
const ThumbActions = ({ deviation, actions, className, children })=>{
    var _deviation;
    const dropdownId = useUniqueId();
    const logger = useBiLogger();
    const { filteredItems } = useDropdownItems(actions);
    const typeid = getDeviationResourceType(deviation);
    const onOpen = useCallback(()=>{
        var _deviation;
        if (!((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.deviationId)) {
            return;
        }
        logger(BiData({
            evid: 417,
            typeid,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            feed_mode: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            is_grouped: BiContextProvidedValue
        }));
    }, [
        logger,
        typeid,
        (_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.deviationId
    ]);
    if (!filteredItems.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        onOpen: onOpen
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        className: className,
        "aria-owns": dropdownId
    }, children), /*#__PURE__*/ React.createElement(StandardDropdownMenu, {
        id: dropdownId,
        items: filteredItems,
        role: "menu",
        className: s['menu']
    }));
};
ThumbActions.displayName = 'ThumbActions';
export default ThumbActions;
